import React from "react";
import OverleafStore from "../../../../../../stores/overleaf-store";
import Presentation from "./presentation";
import { getEmptyCard } from "../../types";
import deepEqual from 'deep-equal';

const translations = {
  "Can't be blank": "reader.flashcards.required",
  "Should be at most 1024 character(s)": "reader.flashcards.too-long"
};

/**
 * Translate the message if we can, but show it in English if we can't
 */
function tryTranslate(data) {
  if (data && data.content) {
    return data.content.map(err =>
      translations[err] ? i18n.t(translations[err]) : err
    );
  }
  return null;
}

export default class Template extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      front: this.props.front,
      back: this.props.back,
      errors: {}
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.frontChange = this.onChange.bind(this, "front");
    this.backChange = this.onChange.bind(this, "back");
    this.swap = this.swap.bind(this);
  }

  componentDidMount() {
    if (!deepEqual(this.props.front, getEmptyCard()) && deepEqual(this.props.back, getEmptyCard())) {
      this.presentation.focusBack();
    } else {
      this.presentation.focusFront();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.front && !deepEqual(this.props.front, nextProps.front)) {
      this.setState(
        {
          front: nextProps.front,
          back: getEmptyCard()
        },
        () => {
          this.presentation.focusBack();
        }
      );
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.errors.front && !prevState.errors.front) {
      this.presentation.focusFront();
    } else if (this.state.errors.back && !prevState.errors.back) {
      this.presentation.focusBack();
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ errors: {} }, () => {
      let submitPromise;
      const { cancel, cardUUID, deckUUID } = this.props;
      const { back, front } = this.state;
      if (this.props.cardUUID) {
        submitPromise = OverleafStore.updateCard(deckUUID, cardUUID, {
          back,
          front
        });
        Fraction.Reporter.gaEvent(
          "V3/flashcards/panel",
          deckUUID,
          "update card"
        );
      } else {
        submitPromise = OverleafStore.addCard(deckUUID, { back, front });
        Fraction.Reporter.gaEvent("V3/flashcards/panel", deckUUID, "add card");
      }
      submitPromise.then(cancel).catch(({ body: errors }) => {
        this.validateCardFields(errors);
      });
    });
  }

  onChange(key, data) {
    this.setState({
      [key]: data
    });
  }

  swap() {
    this.setState(prevState => ({
      front: prevState.back,
      back: prevState.front
    }));
  }

  validateCardFields(serverErrors) {
    if (serverErrors) {
      this.setState({
        errors: {
          front: tryTranslate(serverErrors.front_side),
          back: tryTranslate(serverErrors.back_side)
        }
      });
    }
  }

  render() {
    const { back, front, errors } = this.state;
    return (
      <Presentation
        back={back}
        backChange={this.backChange}
        cancel={this.props.cancel}
        errors={errors}
        front={front}
        frontChange={this.frontChange}
        onSubmit={this.handleSubmit}
        swap={this.swap}
        ref={el => (this.presentation = el)}
        isbn={this.props.isbn}
      />
    );
  }
}

Template.defaultProps = {
  back: getEmptyCard(),
  front: getEmptyCard()
};
